import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

class Modal extends React.PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            visible: false
        };
        this.onKeydown = this.onKeydown.bind(this);
    }

    componentDidMount() {
        if (this.props.show) {
            this.open();
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.show === true && this.props.show === false) {
            this.open();
        } else if (nextProps.show === false && this.props.show === true) {
            this.close();
        }
    }

    onKeydown(ev) {
        if (ev.key === 'Escape') {
            this.props.onHide();
        }
    }

    open() {
        document.addEventListener('keydown', this.onKeydown);
        document.body.classList.add('modal-open');
        let backdropEl = document.querySelector('.modal-backdrop');
        if (!backdropEl) {
            backdropEl = document.createElement('div');
            backdropEl.classList.add('modal-backdrop', 'fade');
            document.body.appendChild(backdropEl);
        }
        setTimeout(() => {
            backdropEl.classList.add('in');
            this.setState({ visible: true });
        }, 100);
    }

    close() {
        document.body.classList.remove('modal-open');
        document.removeEventListener('keydown', this.onKeydown);
        this.hideBackdrop();
        this.setState({ visible: false });
    }

    hideBackdrop() {
        let backdropEl = document.querySelector('.modal-backdrop');
        if (backdropEl) {
            backdropEl.parentElement.removeChild(backdropEl);
        }
    }

    render() {
        return <div onClick={(ev) => {
            ev.stopPropagation();
            this.props.onHide();
        }} className={cx("modal fade", { in: this.state.visible })} tabIndex="-1" style={{ display: this.props.show ? 'block' : 'none' }}>
            <div className="modal-dialog" onClick={ev => { ev.stopPropagation(); }}>
                <div className="modal-content">
                    {this.props.children}
                </div>
            </div>
        </div>;
    }
}

Modal.propTypes = {
    show: PropTypes.bool,
    children: PropTypes.node,
    onHide: PropTypes.func
};

Modal.defaultProps = {
    show: true,
    onHide: () => { }
};

export default Modal;


// WEBPACK FOOTER //
// ./src/ui/src/component/modal/modal.js